// @flow
import * as React from 'react'

import './FormActions.scss'

export type Props = {
  align: 'center' | 'right',
  children: React.Node,
}

export default class FormActions extends React.Component<Props> {
  static defaultProps = {
    align: 'center',
  }

  render = () => {
    return <div className={this.className}>{this.props.children}</div>
  }

  get className(): string {
    const className = 'FormActions'

    return [className, this.props.align === 'right' ? `${className}--alignRight` : ''].join(' ')
  }
}
